'use client';
import { __rest } from 'tslib';
import React from 'react';
import { TooltipProvider } from '@radix-ui/react-tooltip';
import { ThemeProvider } from 'next-themes';
import { providerThemes } from '../stitches.config.js';

const DesignSystemProvider = (_a) => {
    var { themes, defaultTheme = 'teal' } = _a, props = __rest(_a, ["themes", "defaultTheme"]);
    return React.createElement(ThemeProvider, { attribute: "class", defaultTheme: defaultTheme, value: Object.assign(Object.assign({}, providerThemes), themes) },
        React.createElement(TooltipProvider, Object.assign({}, props)));
};
const DesignSystemTooltipOnlyProvider = (props) => {
    return React.createElement(TooltipProvider, Object.assign({}, props));
};

export { DesignSystemProvider, DesignSystemTooltipOnlyProvider };
